var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgWheelComplementary(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 207.79 207.79",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #9500ff;\n      }\n\n      .cls-2 {\n        fill: none;\n        stroke: #000;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n        stroke-width: 3px;\n      }\n\n      .cls-3 {\n        fill: #ff9f19;\n      }\n\n      .cls-4 {\n        fill: #00ff40;\n      }\n\n      .cls-5 {\n        fill: #ff0;\n      }\n\n      .cls-6 {\n        fill: red;\n      }\n\n      .cls-7 {\n        fill: #0040ff;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Art"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M0,103.9c0,38.45,20.89,72.02,51.94,89.99l51.96-89.99H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M103.9,103.9L51.94,13.91C20.89,31.87,0,65.44,0,103.9h103.9Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M155.85,13.91C140.57,5.06,122.82,0,103.9,0s-36.67,5.06-51.96,13.91l51.96,89.99L155.85,13.91Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M103.9,103.9l-51.96,89.99c15.28,8.84,33.03,13.91,51.96,13.91s36.67-5.06,51.95-13.91l-51.95-89.99h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M155.85,13.91l-51.95,89.99h103.9c0-38.45-20.89-72.02-51.94-89.99Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M155.85,193.88c31.05-17.97,51.94-51.54,51.94-89.99h-103.9l51.95,89.99Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 104.04,
    y1: 149.26,
    x2: 104.04,
    y2: 58.68
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 104.04,
    cy: 58.68,
    r: 6.17
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 103.77,
    cy: 149.11,
    r: 6.17
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWheelComplementary);
export default __webpack_public_path__ + "static/media/wheel-complementary.e1e80f1abf492bd99408b59f905c8e32.svg";
export { ForwardRef as ReactComponent };